module.exports = __webpack_public_path__ + "img/default1.b3ce5ad2.jpg";